import { colors, fontSizes } from "@/app/constants/styles";
import { StyleSheet } from "react-native";

export const orderHistoryStyles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: 10,
    paddingVertical: 15,
    marginHorizontal: 10,
    marginBottom: 10,
    borderRadius: 10,
    backgroundColor: colors.white,
  },
  rowContainer: {
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  timeText: {
    fontSize: fontSizes.x10,
    fontFamily: "HelveticaNeue",
    color: colors.maroon,
    textAlign: "center",
    opacity: 0.5,
  },
  orderNumberText: {
    fontSize: fontSizes.x12,
    fontFamily: "HelveticaNeue-Medium",
    color: colors.maroon,
    marginVertical: 10,
  },
  rowText: {
    fontSize: fontSizes.x10,
    fontFamily: "HelveticaNeue",
    color: colors.maroon,
    marginBottom: 5,
  },
});
